import { Typography } from "@mui/material";
import { StyledRequerido } from "../../styled/Labels";

const RequeridoLabel = ({ text, labelContainerStyle }) => {

  return (
    <StyledRequerido.LabelContainer labelContainerStyle={labelContainerStyle}>
      <StyledRequerido.Icon />
      <Typography>{text}</Typography>
    </StyledRequerido.LabelContainer>
  );
};

export default RequeridoLabel;
